import axios from 'axios'
import { errorHandler } from '../exports/error_management'
const getHash = () =>
    Date.now().toString(36) + Math.random().toString(36).substring(2)

const api = async (method, path, params) => axios[method](path, params)

const epox = date => new Date(date).getTime()

const state = {
    selectedOrder: {},
    orders: [],
    assets: [],
    itemsChanged: false,
    attachments: [],
    selectedAsset: null,
    filter: '',
    error: null,
    loading: false,
    customer: {},
}

const mutations = {
    SET_ATTACHMENTS(state, attachments) {
        state.attachments = attachments
    },
    updateFilter(state, orderTypeId) {
        state.filter = orderTypeId
    },
    SET_LOADING(state, payload) {
        state.loading = payload
    },
    SET_ERROR(state, payload) {
        state.error = payload
    },
    SET_ORDER(state, payload) {
        state.selectedOrder = payload
    },
    SET_ORDERS(state, payload) {
        state.orders = payload
    },
    SET_ASSET(state, payload) {
        state.selectedAsset = payload
    },
    SET_ASSETS(state, payload) {
        state.assets = payload
    },
    SET_CUSTOMER(state, payload) {
        state.customer = payload
    },
    SET_CHANGED(state, x) {
        state.itemsChanged = x
    },
}

const getters = {
    attachments: state => {
        return (state.selectedOrder && state.selectedOrder.attachments) || []
    },
    notes: state => {
        return (state.selectedOrder && state.selectedOrder.notes) || []
    },
    order: state => {
        const order = { ...(state.selectedOrder || {}) }
        delete order.notes
        delete order.attachments
        return order
    },
    getOrderTypeId: state => state.filter,
}

const actions = {
    load({ commit }, initialItems) {
        const attachments = initialItems.map(x => {
            x.hash = x.hash || getHash()
            return x
        })
        commit('SET_ATTACHMENTS', attachments)
        commit('SET_CHANGED', false)
    },

    async delete({state,commit},id){
        try {
            commit('SET_ERROR', null)
            commit('SET_LOADING', true)
         
            const results = await axios.delete(`customer-portal/${id}`)
           
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('SET_LOADING', false)
        }
    },
    merge({ state, commit }, items) {
        items.newFiles.forEach(item => {  
            item.hash = item.hash || getHash()
            const attachments = [...state.attachments]
            let index = attachments.findIndex(x => x.hash == item.hash)
            if (index >= 0) attachments.splice(index, 1, item)
            else attachments.push(item)
            commit('SET_CHANGED', true)
            commit('SET_ATTACHMENTS', attachments)
        });
    },
    
    //////////////////////////orders
    async createOrder({ commit, state }, order) {
        try {
            commit('SET_ERROR', null)
            commit('SET_LOADING', true)
            const customer_id = state.customer.id
            const results = await api(
                'post',
                `customer-portal/${customer_id}/orders`,
                order
            )
            const newOrder = results.data.success.data
            const orders = [...state.orders]
            orders.push(newOrder)
            orders.sort((a, b) => epox(b.updated_at) - epox(a.updated_at))

            commit('SET_ORDER', newOrder)
            commit('SET_ORDERS', orders)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('SET_LOADING', false)
        }
    },
    async editOrder({ commit, state }, order) {
        try {
            commit('SET_ERROR', null)
            commit('SET_LOADING', true)
            const customer_id = state.customer.id
            const results = await api(
                'post',
                `customer-portal/${customer_id}/edit-orders`,
                order
            )
            const newOrder = results.data.success.data
            const orders = [...state.orders]
            orders.push(newOrder)
            orders.sort((a, b) => epox(b.updated_at) - epox(a.updated_at))

            commit('SET_ORDER', newOrder)
            commit('SET_ORDERS', orders)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('SET_LOADING', false)
        }
    },
    
    async fetchOrder({ commit, state }, order_id) {
        try {
            commit('SET_ERROR', null)
            commit('SET_LOADING', true)
            const customer_id = state.customer.id
            const results = await api(
                'get',
                `customer-portal/${customer_id}/orders/${order_id}`
            )
            const order = results.data.success.data
            console.log('orders', order)
            commit('SET_ORDER', order)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async fetchOrders({ commit, state }) {
        try {
            commit('SET_ERROR', null)
            commit('SET_LOADING', true)
            const customer_id = state.customer.id
            const results = await api(
                'get',
                `customer-portal/${customer_id}/orders`
            )
            const orders = results.data.success.data

            orders.sort((a, b) => epox(b.updated_at) - epox(a.updated_at))
            console.log('orders--', orders)
            commit('SET_ORDERS', orders)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async updateOrder({ commit, state }, order) {
        console.log('update', order)
        // const payload = {...order }
        // delete payload.id
        try {
            commit('SET_ERROR', null)
            commit('SET_LOADING', true)
            const customer_id = state.customer.id
            const results = await api(
                'put',
                `customer-portal/${customer_id}/orders/${order.id}`,
                order
            )
            const r_order = results.data.success.data
            const s_orders = [...state.orders]
            const idx = s_orders.findIndex(x => x.id === r_order.id)
            s_orders.splice(idx, 1, r_order)
            s_orders.sort((a, b) => epox(b.updated_at) - epox(a.updated_at))

            commit('SET_ORDER', r_order)
            commit('SET_ORDERS', s_orders)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('SET_LOADING', false)
        }
    },
    //////////////////////assets
    async fetchAsset({ commit, state }, { asset_id }) {
        try {
            commit('SET_ERROR', null)
            commit('SET_LOADING', true)
            const customer_id = state.customer.id
            const results = await api(
                'get',
                `customer-portal/${customer_id}/assets/${asset_id}`
            )
            commit('SET_ASSET', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async fetchAssets({ commit, state }) {
        try {
            commit('SET_ERROR', null)
            commit('SET_LOADING', true)
            const customer_id = state.customer.id
            const results = await api(
                'get',
                `customer-portal/${customer_id}/assets`
            )
            const assets = results.data.success.data
            assets.sort((a, b) => epox(b.updated_at) - epox(a.updated_at))
            commit('SET_ASSETS', assets)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('SET_LOADING', false)
        }
    },
    ////////notes
    async createNote({ dispatch, commit, state }, { order_id, content }) {
        try {
            commit('SET_ERROR', null)
            commit('SET_LOADING', true)
            const customer_id = state.customer.id
            await api(
                'post',
                `customer-portal/${customer_id}/orders/${order_id}/notes`,
                { content }
            )
            await dispatch('fetchOrder', order_id)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async deleteNote({ dispatch, commit, state }, { order_id, note_id }) {
        try {
            commit('SET_ERROR', null)
            commit('SET_LOADING', true)
            const customer_id = state.customer.id
            await api(
                'delete',
                `customer-portal/${customer_id}/orders/${order_id}/notes/${note_id}`
            )
            await dispatch('fetchOrder', order_id)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('SET_LOADING', false)
        }
    },

    ///////////attachments
    async createAttachment({ dispatch, commit, state }, { order_id, payload }) {
        try {
            commit('SET_ERROR', null)
            commit('SET_LOADING', true)
            const customer_id = state.customer.id
            payload.forEach(async item => {
                let url = item.url
                let name = item.name
                let lat = item.lat
                let long = item.long
                let file_extension = item.file_extension
                await api(
                    'post',
                    `customer-portal/${customer_id}/orders/${order_id}/attachments`,
                    { url, name, lat, long,file_extension }
                )
                await dispatch('fetchOrder', order_id)
            })
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('SET_LOADING', false)
        }
    },

    async deleteAttachment(
        { dispatch, commit, state },
        { order_id, attachment_id }
    ) {
        try {
            commit('SET_ERROR', null)
            commit('SET_LOADING', true)
            const customer_id = state.customer.id
            await api(
                'delete',
                `customer-portal/${customer_id}/orders/${order_id}/attachments/${attachment_id}`
            )
            await dispatch('fetchOrder', order_id)
        } catch (err) {
            errorHandler(err)
        } finally {
            commit('SET_LOADING', false)
        }
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
